import React from 'react';

import { Button, Progress, Tooltip, Typography } from 'antd';

import styles from './styles.module.less';

const { Text } = Typography;

export interface ProgressDistributionItem {
  key: string;
  label: string;
  count: number;
  color: string;
  /** Accessible name of the count button. */
  actionLabel: string;
  /** Optional hover hint on the count button. */
  hint?: string;
  onClick: () => void;
}

export interface ProgressDistributionListProps {
  items: ProgressDistributionItem[];
  /** `compact` fits short labels (e.g. "85–99%"), `wide` fits longer ones. */
  variant?: 'compact' | 'wide';
}

/** Rows of label + bar proportional to the largest count + clickable count. */
const ProgressDistributionList: React.FC<ProgressDistributionListProps> = ({
  items,
  variant = 'compact',
}) => {
  const maxCount = Math.max(...items.map(item => item.count), 1);

  return (
    <div className={styles.list}>
      {items.map(item => {
        const countButton = (
          <Button
            type="link"
            className={styles.count}
            aria-label={item.actionLabel}
            onClick={item.onClick}
          >
            {item.count}
          </Button>
        );

        return (
          <div className={`${styles.row} ${styles[variant]}`} key={item.key}>
            <Text className={styles.label}>{item.label}</Text>
            <Progress
              percent={Math.round((item.count / maxCount) * 100)}
              showInfo={false}
              strokeColor={item.color}
            />
            {item.hint ? <Tooltip title={item.hint}>{countButton}</Tooltip> : countButton}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressDistributionList;
